import store from '../store';
import { getUrlParams, setQueryUrl, getModel, getSys, getScreen, getSign, getPhpNow } from '@/utils';
import mixServer from './mixServer';
import { mixServerConfig } from '@/config';
import channelServer from './channelServer';
import { Dialog } from 'vant';
import pay from './pay';
import cookies from '@/cookies';
import { platform } from '@/check';
const isDev = process.env.NODE_ENV === 'development';
const server = {
  ver: getUrlParams('campaign_id'), // 修改ver取得内容为campaign_id，验签为verCheck
  verCheck: getUrlParams('ver'),
  appid: getUrlParams('appid'),
  campaign_id: getUrlParams('campaign_id'),
  idfa: getUrlParams('idfa') || '',
  idfv: getUrlParams('idfv') || 'idfv',
  imei: getUrlParams('imei') || 'imei',
  oaid: getUrlParams('oaid') || '',
  adver: getUrlParams('ver') || '',
  model: getUrlParams('model') || getModel(),
  android_id: getUrlParams('android_id') || '',
  // 微信支付参数
  code: getUrlParams('code'),
  shareParams: {},
  // 在线上报需要的参数
  onlineParams: {},
  expire_time: '',
  // 计时器
  timer: null,
  // 需要提前获取游戏链接
  mixConfigPromise: null,

  // 2021.12.9 个人信息法 游戏使用声明弹窗 同意后才能进入游戏（init）
  gameReady() {
    let currentAgree = localStorage.getItem('ln_agree');
    if ((currentAgree == 1 || !currentAgree) && !localStorage.getItem('ln_status')) {
      // 异步队列
      setTimeout(() => {
        store.commit('SHOW', {
          name: 'GameState',
          params: { isVer: false }
        })
      }, 300);
    } else {
      mixServer.getConfig().then(data => {
        store.commit('SET_OPEN_HEALTH', data.data.is_open_health);
        if (data.data.is_open_health == 1) {
          store.commit('SET_HEALTH', true);
          // store.commit('SET_GAMEDIST', data.data.direction);
          console.log()
          setTimeout(() => {
            store.commit('SET_HEALTH', false);
            this.init();
          }, 2000);
        } else {
          this.init();
        }
      })
    }
  },
  init() {
    const isContinue = this.wxHandle();
    // console.log(isContinue)
    if (!isContinue) return;
    if (isDev) setQueryUrl();
    const isUrlPass = this.checkUrl();
    if (!isUrlPass) {
      document.body.innerHTML = '验签错误，请联系管理员';
      return;
    }
    this.removePayPreloadTrasition();
    this.acceptMessage();
    this.setShareParams();
    // 发送idfa到 sdk
    if (getUrlParams('idfa')) {
      // sendUrlParams(getUrlParams('idfa'))
    }

    this.getMixConfigPromise().then(() => {
      this.setGameFrame();
    });

    // 接口不在这里初始化，在收到登录信息时初始化
    // this.apiInit();
    // 测试在线时长（根据接口返回走防沉迷逻辑）
    // let testParams = { sign: '841ba05e7a9d6c0d9ef804ce682cd358', time: '1599804246994', access_token: '241c0bed8a3f5796bf4b8222b0cb89551e9528bae43302c93ede01856fb578929f896af23ecd17245e454bf54c399d49c23b02343a2bb711', ver: 'd821f19cbb', roleid: '298900778', server_id: '4200049' }
    // this.online(testParams);
  },
  setGameFrame() {
    // const url = isDev ? process.env.VUE_APP_CLIENT_URL : mixServer.game_link;
    const url = mixServer.game_link;
    let gameFrame = document.querySelector('#gameFrame');
    gameFrame.src = `${url}`;
  },
  getMixConfigPromise() {
    if (this.mixConfigPromise) {
      return this.mixConfigPromise;
    } else {
      return (this.mixConfigPromise = mixServer.getConfig());
    }
  },
  apiInit() {
    return new Promise((resolve, reject) => {
      if (this.hasInit) {
        resolve();
        return;
      }
      // 融合配置+初始化
      this.getMixConfigPromise().then(() => {
        mixServer.init().then((res) => {
          // 乐牛配置+初始化
          // console.log(res);
          channelServer.getConfig().then(() => {
            channelServer.init().then(() => {
              this.hasInit = true;
              store.commit('SET_LOADING', false);
              resolve();
            });
          });
        });
      });
    });
  },
  checkUrl() {
    const params = {
      appid: this.appid,
      campaign_id: this.campaign_id,
      ver: this.verCheck
    };
    const sign = getSign('', params);
    const urlSign = getUrlParams('sign');
    // console.log(sign)
    // console.log(urlSign)
    const isPass = sign === urlSign;
    return isPass;
  },
  // 微信浏览器特殊处理
  wxHandle() {
    if (platform.isWeiXin) {
      if (!this.code) {
        const params = {
          redirect_uri: encodeURIComponent(location.href),
          time: getPhpNow(),
          fu_appid: getUrlParams('appid')
        };
        channelServer.getWxPayUrl(params).then(({ data = {} }) => {
          const { url } = data;
          location.href = url;
        });
        return false;
      }
    }
    return true;
  },
  // 去除一开始的支付页面动画
  removePayPreloadTrasition() {
    window.onload = () => {
      document.querySelector('.preload').classList.remove('preload');
    };
  },
  // 接受游戏窗口传递的信息
  acceptMessage() {
    window.addEventListener('message', e => {
      const payload = typeof e.data === 'string' ? { action: e.data } : e.data || {};
      const { action, params } = payload;
      const token = this.getToken();
      console.log(token)
      switch (action) {
        // 弹出登录框
        case 'LOGIN':
          this.apiInit().then(() => {
            if (token) {
              // 有token，自动登录
              const cancelAutoLoginDomain = ['sdk.sh9130.com', 'huanyuantech.com', 'https://h5.uu89.com', 'luckystar001', 'hhycdk.com', 'h5game.jiuyaowangluo.com', 'cls-wd03.youyantech.com', 'shanhai-cdn'];
              if (mixServer.game_link.indexOf('youyantech') > -1) {
                if (!store.state.changeAccClick) {
                  this.autoLogin();
                } else {
                  this.showModal();
                }
              } else {
                if (!cancelAutoLoginDomain.some(v => mixServer.game_link.indexOf(v) > -1)) {
                  this.autoLogin();
                } else {
                  console.log('非自动登录')
                  this.showModal();
                }
              }
            } else {
              // 没有token，不需自动登录，拉起登录窗口
              this.showModal();
            }
          });
          break;
        case 'LOGOUT':
          this.cpChangeAccount();
          break;
        // 下单，拉起支付
        case 'PAY':
          this.handlePay(params);
          break;
        // 支付页面传递过来的，关闭支付页面
        case 'PAY_CLOSE':
          pay.close();
          break;
        // 支付页面传递过来的，在微信浏览器调起支付
        case 'PAY_WEIXIN':
          pay.weixin(params);
          break;
        case 'ROLE_REPORT':
          this.handleRoleReport(params);
          break;
        // sdk红包页面发送消息
        case 'REDACC':
          this.openAccount(params);
          break;
        case 'REDACCSET':
          this.setAccount(params);
          break
        case 'KEFU':
          this.openKefu(params);
          break
        case 'YFREDPACK':
          this.getYfRedPacketData(params)
          break  
        default:
          break;
      }
    });
  },
  showModal() {
    store.commit('SHOW');
  },
  closeModal() {
    store.commit('CLOSE');
  },
  logout() {
    // 清除token
    // thic.clearToken();
    // 重起游戏
    this.reloadGameFrame();
    // 上报时长
    this.online(this.onlineParams);
    sendMsg('LOGOUT_SUCCESS');
  },
  clearToken() {
    cookies.removeItem('ln_h5sdk_user_token');
    cookies.removeItem('ln_h5sdk_guest_token');
  },
  cpChangeAccount() {
    if (mixServer.game_link.indexOf('huanyuantech.com') > -1) {
      sendMsg('LOGOUT_SUCCESS', {});
      setTimeout(() => {
        store.commit('SHOW', 'Login');
      }, 300);
    }
    // setTimeout(() => {
    //   this.showModal();
    //   // store.commit('SHOW', 'Login');
    // }, 100);

    if (mixServer.game_link.indexOf('youyantech.com') > -1) {
      console.log('sdk切换账号');
      sendMsg('LOGOUT_SUCCESS', {});
      store.commit('SET_CHANGECLICK', true);
    }
  },
  reloadGameFrame() {
    const gameFrame = document.querySelector('#gameFrame');
    gameFrame.src = `${gameFrame.src}?v=${new Date().getTime()}`;
    setTimeout(() => {
      store.commit('SHOW', 'Login');
    }, 100);
  },
  handlePay(clientParams) {
    const {
      orderId,
      orderName,
      amount,
      total_fee,
      serverId,
      roleName,
      roleId,
      roleLevel,
      ext,
      flag,
      pay_callback
    } = clientParams;
    const params = {
      order_id: orderId || '',
      order_name: orderName || '',
      is_lnpay: 0,
      amount: amount || '',
      total_fee: total_fee || amount || '',
      server: serverId,
      role: roleName,
      roleid: roleId,
      level: roleLevel || '',
      ext: ext || '',
      flag: flag || '',
      pay_callback: pay_callback || '',
      ln_pay_req: 1,
      ver: this.ver || '',
      // 微信支付参数
      weixin_code: this.code || ''
    };
    // 下单成功拉起支付
    mixServer.pay(params).then(data => {
      const { url = '' } = data;
      // console.log(decodeURIComponent(data.hackjs).replace(/\+/g, ' '))
      // 兼容渠道支付宝支付执行js
      // if (data.hackjs) {
      //   setTimeout(() => {
      //     eval(decodeURIComponent(data.hackjs).replace(/\+/g, ' '))
      //   }, 500);
      // }
      // zf_type=1为乐牛支付 2为苹果支付
      if (data.zf_type == 1) {
        // 根据url确定是否跳转到浏览器支付
        if (getUrlParams('browser') && getUrlParams('appid') != '63352') {
          let payUrl = [url];
          try {
            window.webkit.messageHandlers['receiveUrlData'].postMessage({ params: payUrl });
          } catch (err) {
            console.log('浏览器不支持跳转', err)
          }
        } else {
          const openBrowAppid = ['71288', '71292', '71296']; // 另开浏览器窗口拉起支付
          if (platform.isSafari) {
            // safari无法iframe拉起支付，需要通过用户触发，跳转到新页面
            store.commit('SHOW_OPENCONFIRM', url);
          } else if (openBrowAppid.includes(String(getUrlParams('appid')))) {
            store.commit('SHOW_OPENCONFIRM', url);
          } else {
            pay.show(url);
          }
        }
      } else {
        let payParams = [data.flag, data.order_id, data.zf_type]
        try {
          window.webkit.messageHandlers['payData'].postMessage({ params: payParams })
        } catch (err) {
          console.log('浏览器不支持苹果支付', err)
        }
      }
    });
  },
  handleRoleReport(clientParams) {
    console.log('角色上报开始')
    const {
      type,
      roleInfo: { roleId, roleName, roleLevel, sex, serverId, serverName, roleTime }
    } = clientParams;
    const roleParams = {
      type,
      roleid: roleId,
      rolename: roleName,
      level: roleLevel,
      sex: sex || 0,
      server_id: serverId
    };
    // 角色上报
    this.role(roleParams);

    this.onlineParams = {
      ver: this.ver,
      roleid: roleId,
      server_id: serverId
    };
    // 是否开启红包功能参数
    const rebateAct = {
      ln_uid: channelServer.ln_uid,
      server_no: serverId,
      role_id: roleId,
      level: roleLevel,
      role_name: roleName,
      server_name: serverName
    };
    switch (type) {
      case 1:
        // 创角时，顺便上报入服，并走时长上报流程（现在由游戏上报）
        // this.role({ ...roleParams, type: 3 });
        this.online(this.onlineParams);
        // this.getRebateAct(rebateAct);
        break;
      case 3:
        // 入服，调在线时长接口，并设置后续上报在线时长
        // 入服，调是否开启红包功能
        if (this.timer) clearInterval(this.timer);
        this.online(this.onlineParams);
        this.getRebateAct(rebateAct);
        this.openPushImg();
        setTimeout(() => {
          store.commit('SET_COPYRIGHT', false);
        }, 2000);
        break;
      default:
        break;
    }
  },
  // sdk红包打开账户
  openAccount(params) {
    store.commit('SHOW', params.comName);
  },
  setAccount(params) {
    store.commit('SHOW', params.comName);
  },
  // 打开客服窗口
  openKefu(params) {
    store.commit('SET_OPENKEFU', { url: params.kefuUrl, show: true });
  },
  getYfRedPacketData(params) {
    // console.log(params, '1研发红包参数')
    mixServer.getYfRebate({info:  params}).then(data => {
      // console.log(data, '获取红包数据1')
      sendMsg('SEND_YF_REDPACK', {data: data});
    });
  },
  // 在线时长上报(包括首次和后续)
  online(onlineParams) {
    // if (getUrlParams('game_id') == 88) return; // 当游戏id为88时不执行上报时长逻辑
    // 首次上报
    mixServer.online({ ...onlineParams, seconds: 0, type: 1 }).then(data => {
      // 弹出实名登记
      const toCert = data => {
        store.commit('SHOW', {
          name: 'Certification',
          // 在线时长弹出，一定是强制
          params: { ...data, isForceCert: true, is_close: false }
        });
      };
      // 需要弹出实名认证
      // if (mixServer.isAntiAddiction == 1) {
      //   if (data.is_allow_online == 0) {
      //     if (store.state.user.cert_type != 1) {
      //       // 如果登录时没有弹出实名认证，则在这里弹出
      //       toCert(data);
      //     }
      //     // 如果不允许在线，强制重启游戏,不后续上报
      //     this.reloadGameFrame();
      //     return;
      //   }
      // }
      this.expire_time = data.expire_time;
      if (mixServer.isAntiAddiction == 1) {
        if (data.is_allow_online == 0) {
          if (data.type == 0) {
            store.commit('CLOSE');
          } else if (data.type == 1) { // 强制退出游戏的弹窗不可关闭
            Dialog.alert({
              title: '',
              message: data.cert_msg,
              theme: 'round-button'
            }).then(() => {
              this.reloadGameFrame(); // 退出游戏
            });
            clearInterval(this.timer);
            return
          } else if (data.type == 2) { // 实名认证弹窗不可关闭
            store.commit('SHOW', {
              name: 'Certification',
              params: { cert_msg: data.cert_msg, is_close: false }
            });
            clearInterval(this.timer);
            return;
          }
        } else if (data.is_allow_online == 1) {
          if (data.type == 0) {
            store.commit('CLOSE');
          } else if (data.type == 2) { // 弹窗实名认证弹窗，可关闭
            store.commit('SHOW', {
              name: 'Certification',
              params: { cert_msg: data.cert_msg, is_close: true }
            });
          }
        }
      }
      // 后续上报
      const alive = mixServer.initData.alive;
      if (alive) {
        this.timer = setInterval(() => {
          mixServer.online({ ...onlineParams, seconds: alive, type: 2 }).then(data => {
            // console.log(data);
            if (mixServer.isAntiAddiction == 1) {
              console.log('进入is_anti_addiction')
              if (data.is_allow_online == 0) {
                console.log('进入is_allow_online')
                if (data.type == 0) {
                  store.commit('CLOSE');
                } else if (data.type == 1) { // 强制退出游戏的弹窗不可关闭
                  console.log('进入type', type)
                  Dialog.alert({
                    title: '',
                    message: data.cert_msg,
                    theme: 'round-button'
                  }).then(() => {
                    this.reloadGameFrame(); // 退出游戏
                  });
                  clearInterval(this.timer);
                } else if (data.type == 2) { // 实名认证弹窗不可关闭
                  store.commit('SHOW', {
                    name: 'Certification',
                    params: { cert_msg: data.cert_msg, is_close: false }
                  });
                  clearInterval(this.timer);
                }
                // 如果不允许在线，强制重启游戏,不后续上报
                // toCert(data);
                // this.reloadGameFrame();
                // clearInterval(this.timer);
              } else if (data.is_allow_online == 1) {
                if (data.type == 0) {
                  // store.commit('CLOSE');
                } else if (data.type == 2) { // 弹窗实名认证弹窗，可关闭
                  store.commit('SHOW', {
                    name: 'Certification',
                    params: { cert_msg: data.cert_msg, is_close: true }
                  });
                }
              } else {
                console.log('都不是')
              }
            }
          });
        }, +mixServer.initData.alive * 1000);
      }
    });
  },
  // 设置共用参数
  setShareParams() {
    this.shareParams = {
      sdkver: 'h5',
      adver: this.adver,
      device: 7,
      idfa: this.idfa,
      idfv: this.idfv,
      imei: this.imei,
      oaid: this.oaid,
      android_id: this.android_id,
      imsi: 'imsi',
      version: '1.0',
      channel_version: '1.0',
      sysname: getSys(),
      screen: getScreen(),
      model: this.model
    };
  },
  // 登录（融合+渠道）
  login(params) {
    // 正常登录
    return channelServer.login(params).then(mixParams => {
      return mixServer.login(mixParams);
    });
  },
  // 手机验证码登录
  loginPhone(params) {
    return channelServer.loginMobile(params).then(mixParams => {
      return mixServer.login(mixParams);
    });
  },
  // 获取token
  getToken() {
    const userToken = cookies.getItem('ln_h5sdk_user_token');
    const guestToken = cookies.getItem('ln_h5sdk_guest_token');
    const token = userToken || guestToken;
    return token;
  },
  // 当检测到有token时自动登录
  autoLogin() {
    const userToken = cookies.getItem('ln_h5sdk_user_token');
    const guestToken = cookies.getItem('ln_h5sdk_guest_token');
    const token = userToken || guestToken;
    if (token) {
      channelServer.autoLogin({ token });
    }
  },
  // 角色上报（融合+渠道）
  role(params) {
    mixServer.role(params);
    channelServer.role(params);
  },
  // 是否开启红包
  getRebateAct(params) {
    mixServer.getRebate(params).then(data => {
      if (data.open == 1) {
        store.commit('SET_OPEN', true);
        let rebateUrl = data.url.replace('http://', 'https://');
        store.commit('SET_REBATEURL', `${rebateUrl}?tk=${data.tk}&access_token=${mixServerConfig.access_token}&sdk=h5`);
        store.commit('SET_VERTICALRB', data.is_vertical_open);
        // if (data.auto_popup == 1) {
        //   store.commit('SET_AUTOOPENREB', true);
        // }
      } else {
        store.commit('SET_OPEN', false);
      }
    })
  },
  // sdk拍脸图弹窗推送
  openPushImg() {
    console.log('角色入服开启弹窗：', store.state.pushImgConfig);
    if (store.state.pushImgConfig.is_popup == 1) {
      setTimeout(() => {
       store.commit('SET_PUSHSHOW', true);
      }, 1500);
    }
  },
};

// 发送信息给游戏窗口
export const sendMsg = (msg = {}, params = {}) => {
  const gameFrame = document.querySelector('#gameFrame');
  const gameWin = gameFrame.contentWindow;
  // 传进来的params为对象，需转换为原本SDK的参数形式，即[param1,param2,...]这种
  const payload = { action: msg, params: Object.values(params) };
  gameWin.postMessage(payload, '*');
};

export default server;
